const NflTestFeed = [
  {
    game: {
      quarter: 1
    },
    event: {
      home_score: 0,
      away_score: 0,
      type: 'match_started',
      description: 'Match Started',
      is_live: true,
      home_team_possesses: true,
      away_team_possesses: false,
      time_left_in_quarter: '15:00',
      current_down: 1,
      yards_to_go_for_first: 10,
      current_yard_line: 'ARZ 25'
    }
  },
  {
    game: {
      quarter: 1
    },
    event: {
      home_score: 3,
      away_score: 0,
      type: 'score_change',
      description: 'Field Goal - Harrison Butker 33 yd FG',
      is_live: true,
      home_team_possesses: true,
      away_team_possesses: false,
      time_left_in_quarter: '11:02',
      current_down: 4,
      yards_to_go_for_first: 2,
      current_yard_line: 'ATL 15'
    }
  },
  {
    game: {
      quarter: 1
    },
    event: {
      home_score: 6,
      away_score: 0,
      type: 'score_change',
      description: 'Field Goal - Harrison Butker 37 yd FG',
      is_live: true,
      home_team_possesses: true,
      away_team_possesses: false,
      time_left_in_quarter: '08:36',
      current_down: 2,
      yards_to_go_for_first: 5,
      current_yard_line: 'BLT 35'
    }
  },
  {
    game: {
      quarter: 1
    },
    event: {
      home_score: 6,
      away_score: 0,
      type: 'possession_change',
      description:
        'J.Sanders kicks 65 yards from MIA 35 to the NYJ End Zone. Touchback.',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '02:25',
      current_down: 1,
      yards_to_go_for_first: 7,
      current_yard_line: 'BUF 15'
    }
  },
  {
    game: {
      quarter: 1
    },
    event: {
      home_score: 13,
      away_score: 0,
      type: 'touchdown',
      description: 'Touchdown - Xavier Worthy 22 yd pass from Carson Wentz',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '02:25',
      current_down: 1,
      yards_to_go_for_first: 7,
      current_yard_line: 'BUF 15'
    }
  },
  {
    game: {
      quarter: 1
    },
    event: {
      home_score: 13,
      away_score: 0,
      type: 'period_end',
      description: 'Period End',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: false,
      time_left_in_quarter: '00:00',
      current_down: 0,
      yards_to_go_for_first: 8,
      current_yard_line: 'CAR 13'
    }
  },
  {
    game: {
      quarter: 2
    },
    event: {
      home_score: 13,
      away_score: 0,
      type: 'period_start',
      description: 'Period Start',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '15:00',
      current_down: 0,
      yards_to_go_for_first: 5,
      current_yard_line: 'CHI 13'
    }
  },
  {
    game: {
      quarter: 2
    },
    event: {
      home_score: 13,
      away_score: 0,
      type: 'possession_change',
      description:
        'T.Morstead punts 44 yards to MIA 40, Center-T.Hennessy. Out of bounds.',
      is_live: true,
      home_team_possesses: true,
      away_team_possesses: false,
      time_left_in_quarter: '14:00',
      current_down: 3,
      yards_to_go_for_first: 4,
      current_yard_line: 'CIN 24'
    }
  },
  {
    game: {
      quarter: 2
    },
    event: {
      home_score: 13,
      away_score: 0,
      type: 'possession_change',
      description:
        'J.Moody kicks 61 yards from SF 35 to the LA 4. J.Whittington returns the kickoff. Tackled by B.Willis; N.McCloud at LA 34.',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '14:30',
      current_down: 3,
      yards_to_go_for_first: 4,
      current_yard_line: 'CIN 24'
    }
  },
  {
    game: {
      quarter: 2
    },
    event: {
      home_score: 13,
      away_score: 3,
      type: 'score_change',
      description: 'Field Goal - Jake Bates 55 yd FG',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '14:00',
      current_down: 3,
      yards_to_go_for_first: 4,
      current_yard_line: 'CIN 24'
    }
  },
  {
    game: {
      quarter: 2
    },
    event: {
      home_score: 13,
      away_score: 9,
      type: 'touchdown',
      description: 'Touchdown - Kaden Davis 61 yd pass from Nate Sudfeld',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '12:00',
      current_down: 3,
      yards_to_go_for_first: 2,
      current_yard_line: 'CLV 24'
    }
  },
  {
    game: {
      quarter: 2
    },
    event: {
      home_score: 16,
      away_score: 9,
      type: 'score_change',
      description: 'Field Goal - Harrison Butker 56 yd FG',
      is_live: true,
      home_team_possesses: true,
      away_team_possesses: false,
      time_left_in_quarter: '10:00',
      current_down: 2,
      yards_to_go_for_first: 10,
      current_yard_line: 'DAL 31'
    }
  },
  {
    game: {
      quarter: 2
    },
    event: {
      home_score: 16,
      away_score: 12,
      type: 'score_change',
      description: 'Field Goal - Jake Bates 23 yd FG',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '8:00',
      current_down: 2,
      yards_to_go_for_first: 10,
      current_yard_line: 'DEN 18'
    }
  },
  {
    game: {
      quarter: 2
    },
    event: {
      home_score: 16,
      away_score: 12,
      type: 'period_end',
      description: 'Period End',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: false,
      time_left_in_quarter: '00:00',
      current_down: 0,
      yards_to_go_for_first: 10,
      current_yard_line: 'DET 16'
    }
  },
  {
    game: {
      quarter: 3
    },
    event: {
      home_score: 16,
      away_score: 12,
      type: 'period_start',
      description: 'Period Start',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '15:00',
      current_down: 0,
      yards_to_go_for_first: 10,
      current_yard_line: 'GB 19'
    }
  },
  {
    game: {
      quarter: 3
    },
    event: {
      home_score: 16,
      away_score: 12,
      type: 'possession_change',
      description:
        'J.Bailey punts 44 yards to NYJ 13, Center-Z.Triner. X.Gipson returned punt from the NYJ 13. Tackled by S.Neal at NYJ 13.',
      is_live: true,
      home_team_possesses: true,
      away_team_possesses: false,
      time_left_in_quarter: '14:10',
      current_down: 3,
      yards_to_go_for_first: 10,
      current_yard_line: 'HST 16'
    }
  },
  {
    game: {
      quarter: 3
    },
    event: {
      home_score: 16,
      away_score: 12,
      type: 'possession_change',
      description:
        'M.Dickson punts 38 yards to MIN 30, Center-C.Stoll. T.Thomas MUFFS catch. Fumble RECOVERED by SEA-G.Hebert at MIN 32. Tackled by MIN at MIN 32.',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '13:10',
      current_down: 3,
      yards_to_go_for_first: 10,
      current_yard_line: 'HST 16'
    }
  },
  {
    game: {
      quarter: 3
    },
    event: {
      home_score: 16,
      away_score: 15,
      type: 'score_change',
      description: 'Field Goal - Jake Bates 23 yd FG',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '12:10',
      current_down: 3,
      yards_to_go_for_first: 10,
      current_yard_line: 'HST 16'
    }
  },
  {
    game: {
      quarter: 3
    },
    event: {
      home_score: 16,
      away_score: 15,
      type: 'period_end',
      description: 'Period End',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: false,
      time_left_in_quarter: '00:10',
      current_down: 0,
      yards_to_go_for_first: 10,
      current_yard_line: 'IND 45'
    }
  },
  {
    game: {
      quarter: 4
    },
    event: {
      home_score: 16,
      away_score: 15,
      type: 'period_start',
      description: 'Period Start',
      is_live: true,
      home_team_possesses: true,
      away_team_possesses: false,
      time_left_in_quarter: '15:00',
      current_down: 0,
      yards_to_go_for_first: 10,
      current_yard_line: 'JAX 12'
    }
  },
  {
    game: {
      quarter: 4
    },
    event: {
      home_score: 23,
      away_score: 15,
      type: 'touchdown',
      description: 'Touchdown - Cornell Powell 64 yd pass from Chris Oladokun',
      is_live: true,
      home_team_possesses: true,
      away_team_possesses: false,
      time_left_in_quarter: '10:10',
      current_down: 4,
      yards_to_go_for_first: 10,
      current_yard_line: 'KC 12'
    }
  },
  {
    game: {
      quarter: 4
    },
    event: {
      home_score: 23,
      away_score: 21,
      type: 'touchdown',
      description: 'Touchdown - Hendon Hooker 7 yd run',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '2:00',
      current_down: 3,
      yards_to_go_for_first: 10,
      current_yard_line: 'LV 10'
    }
  },
  {
    game: {
      quarter: 4
    },
    event: {
      home_score: 23,
      away_score: 24,
      type: 'score_change',
      description: 'Field Goal - Jake Bates 43 yd FG',
      is_live: true,
      home_team_possesses: false,
      away_team_possesses: true,
      time_left_in_quarter: '00:10',
      current_down: 4,
      yards_to_go_for_first: 10,
      current_yard_line: 'LAC 10'
    }
  },
  {
    game: {
      quarter: 4
    },
    event: {
      home_score: 23,
      away_score: 24,
      type: 'match_ended',
      description: 'Match End',
      is_live: false,
      home_team_possesses: false,
      away_team_possesses: false,
      time_left_in_quarter: '00:00',
      current_down: 0,
      yards_to_go_for_first: 2,
      current_yard_line: 'LA 10'
    }
  }
]

export { NflTestFeed }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/sportradar/enum/NflEventTestFeed.js